import React, { forwardRef } from 'react';

import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import Image from 'react-bootstrap/Image';

const CustomPicker = forwardRef(({ id, name, onChange, onClick, disabled, value, error }, ref) => (
  <InputGroup>
    <FormControl
      name={name}
      ref={ref}
      id={id}
      onChange={onChange}
      onClick={onClick}
      onKeyDown={e => e.preventDefault()}
      disabled={disabled}
      value={value}
      placeholder=' '
      className={error && 'error'}
    />
    <InputGroup.Append>
      <InputGroup.Text>
        <Image className='calendar-image'
          src={`${process.env.PUBLIC_URL}/images/${(disabled ? 'calendar-disabled.svg' : 'calendar.svg')}`}
          alt='logo'
          width='16' height='16' />
      </InputGroup.Text>
    </InputGroup.Append>
  </InputGroup>
));

export { CustomPicker };
